import { useActiveProject } from "@/features/project/ActiveProject";
import { Customer } from "@/features/projects/cards/Customer";
import { t } from "@repo/translation";
import { ModalSheet } from "@repo/ui";

interface CustomerModalProps {
  isOpen: boolean;
  closeModal: () => void;
}

export const CustomerModal = ({ isOpen, closeModal }: CustomerModalProps) => {
  const { opportunity } = useActiveProject();

  if (!opportunity) {
    return null;
  }

  return (
    <ModalSheet
      title={t("label.customer")}
      visible={isOpen}
      onClose={closeModal}
      onBack={closeModal}
    >
      <Customer opportunity={opportunity} />
    </ModalSheet>
  );
};
